export default __webpack_public_path__ + "static/jura-bg-92f83c5e5862bed9a73cf98c7db4c0f3.png";